import { useEffect } from "react";

const ANSWER_ACTION_SELECTOR = 'button[data-md-answer-action="true"]';

const isVisible = (element) => {
  const rect = element.getBoundingClientRect();
  const style = window.getComputedStyle(element);

  return (
    rect.width > 0 &&
    rect.height > 0 &&
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    style.opacity !== "0"
  );
};

const getEnabledAnswerActionButton = () =>
  Array.from(document.querySelectorAll(ANSWER_ACTION_SELECTOR)).find(
    (button) => !button.disabled && isVisible(button),
  );

const isMultilineEditor = (target) => {
  if (!target?.closest) return false;

  return Boolean(
    target.closest("textarea") || target.closest('[contenteditable="true"]'),
  );
};

const useEnterAnswerShortcut = () => {
  useEffect(() => {
    const handleEnterAnswerShortcut = (event) => {
      if (event.key !== "Enter" || event.repeat || event.isComposing) return;
      if (event.defaultPrevented) return;
      if (event.target?.closest?.("button")) return;
      if (isMultilineEditor(event.target)) return;

      const answerActionButton = getEnabledAnswerActionButton();
      if (!answerActionButton) return;

      event.preventDefault();
      answerActionButton.click();
    };

    document.addEventListener("keydown", handleEnterAnswerShortcut);

    return () => {
      document.removeEventListener("keydown", handleEnterAnswerShortcut);
    };
  }, []);
};

export default useEnterAnswerShortcut;
